import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo(params) {
    return request({
        url: '/admin/info',
        method: 'get',
        params: params
    })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function changePw(userName,oldPassword, newPassword) {
  return request({
    url: '/admin/updatePassword',
    method: 'post',
    data: {
      userName,
      oldPassword,
      newPassword
    }
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

export function getNoticeMessage() {
  return request({
    url: '/admin/getNoticeMessage',
    method: 'get',
  })
}

export function updateNoticeMessageStatus(id) {
  return request({
    url: '/admin/updateNoticeMessageStatus/'+ id,
    method: 'get',
  })
}





// WEBPACK FOOTER //
// ./src/api/login.js